import { usePathname } from 'next/navigation'
import { useState } from 'react'

import { clearSurveyType } from '../store/slice/submission-slice'
import { SURVEY_CATEGORY } from '../types/global.types'

import { useAppDispatch } from './use-app-dispatch'
import { useAppSelector } from './use-app-selector'

export function usePreventExitSurvey() {
  const pathname = usePathname()
  const dispatch = useAppDispatch()
  const { surveyType: surveyType } = useAppSelector((state) => state.submission)

  const [showPreventAlert, setShowPreventAlert] = useState<boolean>(false)

  const surveyPathRegex = /^\/survey\/\w+\/take-survey$/
  const isPathnameIncluded =
    surveyPathRegex.test(pathname) || pathname === '/auth/partner/home/welcome-survey/take'
  const isSurveyIncluded =
    surveyType &&
    [
      SURVEY_CATEGORY.WELCOME_SURVEY,
      SURVEY_CATEGORY.DG,
      SURVEY_CATEGORY.INT,
      SURVEY_CATEGORY.IEN,
      SURVEY_CATEGORY.IPO,
    ].includes(surveyType as SURVEY_CATEGORY)

  const checkPreventStatus = () => {
    if (isPathnameIncluded && isSurveyIncluded) {
      setShowPreventAlert(true)
      return true
    }

    return false
  }

  const dismiss = () => {
    setShowPreventAlert(false)
    return dispatch(clearSurveyType())
  }

  return { checkPreventStatus, showPreventAlert, setShowPreventAlert, dismiss }
}
